var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-20"},[_c('ToDoNotesIconSection'),_c('Survey',{staticClass:"mt-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }